<script lang="ts">
	import { setContext } from 'svelte';
	import { writable } from 'svelte/store';
	import type { FlowContainerContext } from '../../types/FlowContainerTypes';

	let { currentPageStore = writable<number | null>(null), flow, pages } = $props();
	let pageDone = writable<any>({});
	let internalPages = writable<any>([]);

	export function setPage(pageNumber: number) {
		//Ignore a switch to the same page.
		if ($currentPageStore == pageNumber) return;

		const targetPageNumber = Math.max(0, Math.min(pageNumber, $internalPages.length - 1));

		for (let index = 0; index < targetPageNumber; index++) {
			if (!$pageDone[index]) return;
		}

		$currentPageStore = targetPageNumber;
	}

	setContext<FlowContainerContext>('enzianFlowContainer', {
		registerPage: (page) => {
			$internalPages = [...$internalPages, page];

			if ($currentPageStore == null) {
				$currentPageStore = 0;
			}

			return $internalPages.length - 1;
		},
		nextPage: () => {
			$pageDone[$currentPageStore!] = true;
			$currentPageStore! += 1;
		},
		previousPage: () => {
			$currentPageStore! -= 1;
		},
		setPage: setPage,
		currentPage: currentPageStore,
		pageDone,
		pages: internalPages
	});
</script>

<div class="grid grid-rows-[auto_1fr] h-full overflow-y-auto gap-4">
	<!-- Step container-->
	{@render flow?.()}

	<!--Page container -->
	{@render pages?.()}
</div>
